import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IImageTile) {
    (function(IImageTileStyle) {
        IImageTileStyle.build = function(partial) {
            return _object_spread({
                animation_on_hover: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IImageTile.IImageTileStyle || (IImageTile.IImageTileStyle = {}));
    (function(ImageTileVariant) {
        ImageTileVariant["IMAGE_TILE_VARIANT_UNKNOWN"] = "IMAGE_TILE_VARIANT_UNKNOWN";
        /**
     * Used when the image is rectangular aspect ratio is 1:1
     */ ImageTileVariant["SQUARE_TILE"] = "SQUARE_TILE";
        /**
     * Used when the image is circular with default size
     */ ImageTileVariant["CIRCLE_TILE"] = "CIRCLE_TILE";
        /**
     * Used when the image is circular with small size
     */ ImageTileVariant["SMALL_CIRCLE_TILE"] = "SMALL_CIRCLE_TILE";
        /**
     * Used when the image is rectangular with aspect ratio 3:4
     */ ImageTileVariant["PORTRAIT_TILE"] = "PORTRAIT_TILE";
        /**
     * Used when the image is rectangular with aspect ratio 4:3
     */ ImageTileVariant["LANDSCAPE_TILE"] = "LANDSCAPE_TILE";
        /**
     * Used when the tile container is rectangular with rounded corners with aspect ratio 5:4;
     * The image is rendered in the lower left corner
     */ ImageTileVariant["LANDSCAPE_IMAGE_CUTOUT"] = "LANDSCAPE_IMAGE_CUTOUT";
        /**
     * Used when the image is rectangular with aspect ratio 3:1
     */ ImageTileVariant["THIN_LANDSCAPE_TILE"] = "THIN_LANDSCAPE_TILE";
    })(IImageTile.ImageTileVariant || (IImageTile.ImageTileVariant = {}));
    (function(ImageTileAnimation) {
        ImageTileAnimation["IMAGE_TILE_ANIMATION_UNKNOWN"] = "IMAGE_TILE_ANIMATION_UNKNOWN";
        ImageTileAnimation["ZOOM"] = "ZOOM";
        ImageTileAnimation["UNDERLINE"] = "UNDERLINE";
    })(IImageTile.ImageTileAnimation || (IImageTile.ImageTileAnimation = {}));
    IImageTile.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IImageTile || (IImageTile = {}));
export var IImageTile;
